import { useEffect, useRef, useCallback } from 'react'

function useDebounce(fn, delay = 300, dep = []) {
    const { current } = useRef({ fn, timer: null });
    useEffect(function () {
        current.fn = fn;
    }, [fn]);

    return useCallback(function f(...args) {
        if (current.timer) {
            clearTimeout(current.timer);
        }
        current.timer = setTimeout(() => {
            current.fn.call(this, ...args);
        }, delay);
    }, dep)
}

// 处理外层表单数据,特定的布尔值转'Y'或'N'
function handleFormDetail(formData, fieldList) {
    let formDetail = { ...formData }
    const newList = [...fieldList]
    fieldList.forEach(x => {
        // console.log('x',x);
        const fieldName = x.NAME.toUpperCase()
        if (x.DISPLAYTYPE === 'boolean' && x.DATATYPE === 'string') {
            formDetail[fieldName] = formDetail[fieldName] ? 'Y' : 'N'
        }
    })
    // console.log('formDetail', formDetail);
    return formDetail
}

// 处理弹窗里面表单的数据,全部布尔值转'Y'或'N'
function handleModelFormDetail(modelFormData) {
    let modelFormDetail = { ...modelFormData }
    for (let item in modelFormDetail) {
        if (typeof(modelFormDetail[item]) === 'boolean') {
            modelFormDetail[item] = modelFormDetail[item] ? 'Y' : 'N'
        }
    }
    return modelFormDetail
}
// 处理弹窗里面表单的数据,全部'Y'或'N'转布尔值
function modelFormDetailToBoolean(modelFormData) {
    let modelFormDetail = { ...modelFormData }
    for (let item in modelFormDetail) {
        if (modelFormDetail[item] === 'Y' || modelFormDetail[item] === 'N') {
            modelFormDetail[item] = modelFormDetail[item] === 'Y'
        }
    }
    return modelFormDetail
}

export { useDebounce, handleFormDetail, handleModelFormDetail, modelFormDetailToBoolean }